import styled from 'styled-components';
import { colorWhite, mediaLg, mediaMd, mediaSm, mediaXs } from '../../../../../../theme/theme-helper-selectors';
import { PrimaryLink } from 'components/button/styled';
import { Button } from 'kl-b2c-ui-kit';

export const BlockTitleContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 0 0 35px 0;

    @media (${mediaSm}) {
        margin: 0 0 48px 0;
    }
`;

export const MediaContainer = styled.div`
    margin: 0 0 160px 0;
    text-align: center;

    @media (${mediaLg}) {
        margin: 0 0 120px 0;
    }

    @media (${mediaMd}) {
        margin: 0 0 100px 0;
    }
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
    margin: 0 -24px 48px;

    @media (${mediaSm}) {
        flex-direction: column;
        margin: 0 0 48px 0;
    }
`;

const getBlockWidth = (isActive: boolean, length: number) => {
    switch (length) {
        case 1:
            return '100%';
            break;
        case 2:
            return '50%';
            break;
        default:
            return isActive ? '60%' : '20%';
    }
};

export const MediaBlockItem = styled.a<{ isActive: boolean; length: number }>`
    width: ${({ isActive, length }) => getBlockWidth(isActive, length)};
    transition: width 0.5s ease;
    height: 440px;
    color: ${colorWhite};
    border-radius: 16px;
    text-align: left;

    &:hover {
        color: ${colorWhite};
    }

    @media (${mediaSm}) {
        width: 100%;
        height: auto;
    }
`;

export const MediaBlockImage = styled.div<{ url: string }>`
    border-radius: 16px;
    height: 297px;
    background-image: ${({ url }) => `url(${url})`};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin: 0 0 16px 0;
    position: relative;
`;

export const MediaBlockTitle = styled.h4`
    font-size: 18px;
    line-height: 21px;
    margin: 0 0 10px 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const MediaBlockDescription = styled.p`
    font-size: 14px;
    line-height: 16px;
    opacity: 0.6;

    max-height: 125px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;

    b {
        font-weight: 600;
    }
`;

export const MediaBlockButton = styled(PrimaryLink)<{ isVisible: boolean }>`
    padding: 12px 16px;
    font-size: 22px;
    line-height: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 50px;
    min-width: 150px;
    white-space: nowrap;
    display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
    flex-direction: row;
    gap: 10px;

    @media (${mediaSm}) {
        display: flex;
        font-size: 15px;
        line-height: 17px;
        height: 34px;
        align-items: center;
        justify-content: center;
        gap: 5px;

        svg {
            width: 17px;
            height: 17px;
        }
    }
`;

export const MediaBlockIcon = styled.div<{ isVisible: boolean }>`
    display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 2px solid ${colorWhite};
    opacity: 0.8;
    position: absolute;
    top: 16px;
    right: 16px;

    @media (${mediaSm}) {
        display: none;
    }
`;

export const MediaBlockMoreBtn = styled(Button)`
    padding: 25px 34px;
    margin: 0 auto;

    background: ${({ theme }) => theme.palette.background};
    border: 2px solid rgba(255, 255, 255, 0.8);
    font-weight: 500;
    height: 74px;

    font-size: 24px;
    line-height: 24px;
    letter-spacing: 0;

    &:hover {
        background: ${({ theme }) => theme.palette.background};
        opacity: 1;
    }

    @media (${mediaMd}) {
        height: 60px;
        font-size: 18px;
        line-height: 18px;
    }

    @media (${mediaXs}) {
        width: 100%;
    }
`;
